import { Component, OnInit, ViewChild, AfterViewInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialog } from '@angular/material/dialog';
import { TitleComponent } from 'src/app/shared/components/title/title.component';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { HolidaysService } from 'src/app/shared/services/holidays/holidays.service';
import { DeleteComponent } from 'src/app/shared/components/delete/delete.component';

@Component({
  selector: 'app-priority-periods',
  imports: [
    CommonModule,
    RouterLink,
    TitleComponent,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatSortModule,
    MatTabsModule,
    LoaderComponent,
  ],
  templateUrl: './priority-periods.component.html',
  styleUrls: [
    './priority-periods.component.css',
    '../../../shared/styles/layout.css',
  ],
})
export class PriorityPeriodsComponent implements OnInit, AfterViewInit {
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    'exercise',
    'min_years_worked',
    'start_date',
    'end_date',
    'actions',
  ];

  @ViewChild(MatSort) sort!: MatSort;
  readonly dialog = inject(MatDialog);

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private holidaysService: HolidaysService
  ) {}

  get isLoading() {
    return this.loaderService.getLoader();
  }

  ngOnInit() {
    this.loadData();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  loadData(): void {
    this.loaderService.showLoader();
    this.holidaysService.getVacationPriorityPeriods().subscribe({
      next: (periods) => {
        this.dataSource.data = periods.filter((p) => !p.is_deleted);
        this.loaderService.hideLoader();
      },
      error: (error) => {
        console.error('Error loading priority periods:', error);
        this.loaderService.hideLoader();
      },
    });
  }

  goToPriorityPeriod(periodId: number, event?: Event) {
    if (event) {
      event.stopPropagation(); // Prevent row click if called from button
    }
    if (!periodId) return;
    this.router.navigate(['/home/vacations/priority-periods', periodId, 'edit']);
  }

  deletePriorityPeriod(event: Event, periodId: number, exerciseName: string) {
    event.stopPropagation(); // Prevent row click navigation

    const dialogRef = this.dialog.open(DeleteComponent, {
      width: '550px',
      data: {
        title: '¿Seguro que quieres eliminar este período de prioridad?',
        message: exerciseName,
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        handler: () => this.holidaysService.deleteVacationPriorityPeriod(periodId),
      },
    });

    const dialogSub = dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        // Refresh data after deletion
        this.loadData();
      }
    });
  }
}
